export default __webpack_public_path__ + "static/typography-image-c-05def0a297e178331f48da3c4ba951dfe9c2f232a69b293603397640a5343fe3.png";